export default function MySQL_RPAD() {
  return (
    <div>
      <h2>MySQL_RPAD</h2>    </div>
  );
}